const featureNames = Object.freeze({
  ACQUISITION_BOOSTER: 'acquisition-booster',
  AUTHORIZATION: 'authorization',
  BACKOFFICE_LEADS: 'backoffice-leads',
  BACKOFFICE_POSTS: 'backoffice-posts',
  BILLWERK: 'billwerk',
  CONTACTS: 'contacts',
  COMPANY_USER: 'company-user',
  COMPANY: 'company',
  CONTRACT: 'contract',
  CRM: 'crm',
  CLIENT_ADVISOR: 'client-advisor',
  CONTENT_CREATOR: 'content-creator',
  SUB_COMPANY_CREATOR: 'sub-company-creator',
  NOTIFICATIONS: 'notifications',
  HOPPERMATION: 'hoppermation',
  SALES_PERSON: 'sales-person',
  SSO: 'sso',
  STATISTICS: 'bo-statistics',
  DASHBOARD_PRESENTATION: 'dashboard-presentation',
  CONNECTION_MANAGER: 'connection-manager',
  GOOGLE_CALENDAR: 'google-calendar',
  KONSTANTINE: 'konstantine',
  STATISTIC_DASHBOARD: 'statistic-dashboard',
  PERFORMANCE_MARKETING: 'performance-marketing',
  PLOT_VALUATION: 'lp-grundstuecksbewertung',
  VALUATION: 'valuation',
  VARIANT: 'variant',
  ZOHO: 'zoho',
  EXPORT_CONNECTIONS_CSV: 'export-connections-csv',
  EXPORT_CUSTOMERS_STATUS_CSV: 'export-customers-status-csv'
})

export default featureNames
